import $ from 'jquery';
import Slicker from 'components/slicker';
import zipTools from 'components/zip-tools';
import zip from 'lib/util/zip';

var h2hPage = h2hPage || {
  init: function () {
    $("button.tab").on('keydown', function() {
      $('.carousel-inner.slick-initialized.slick-slider.slick-dotted').find('button.tab').attr('tabindex', '-1');
    });
    this.slideshow();
    this.setActiveFirstNavDot();
    $('.h2h-page .carousel-inner').on('afterChange', function () {
      $('.slick-slider .slick-dots li .tab').each(function (index) {
        if ($(this).parent('li').hasClass('slick-active')) {
          $('.additional-nav-holder .dots-container li .tab').each(function (index2) {
            if (index === index2) {
              $('.additional-nav-holder .dots-container li').removeClass('slick-active');
              $(this).parent('li').addClass('slick-active');
            }
          });
        }
      });
    });
    $('.slick-nav-container .dots-container ul li button').click(function() {
      $("html,body").animate({
        scrollTop: 0
      }, 200);
    });
    $('.additional-nav-holder .dots-container li .tab').each(function (index) {
      $(this).click(function () {
        $('.slick-slider li .tab').each(function (index2) {
          if (index === index2) $(this).click();
        });
        $(this).focus();
        $('.additional-nav-holder .dots-container li').removeClass('slick-active');
        $(this).parent('li').addClass('slick-active');
      });
    });
    if ($(window).width() > 1099) {
      $('.compare-more-wrapper-mobile .vca-component-wrapper').clone().appendTo('.slick-active .compare-more-placeholder');
      var compareParagraphHeight = $('.compare-more-placeholder .cv-header > p').height();
      $('.h2h-page .carousel-inner').on('afterChange', function () {
        $('.slick-active .compare-more-wrapper').height(350 + compareParagraphHeight + 'px');
        $($('.compare-more-placeholder .vca-component-wrapper').detach()).appendTo('.slick-active .compare-more-placeholder');
      });
    }
    else {
      $('.h2h-page .carousel-inner').on('beforeChange', function () {
        $("html,body").animate({
          scrollTop: 0
        }, 200);
      });
    }

    $('a[data-id="nav-offers"], a[data-id="nav-inventory"]').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), $(e.currentTarget).attr('href'));
    });
  },
  setActiveFirstNavDot: function () {
    $('.additional-nav-holder .dots-container li:first-child').addClass('slick-active');
  },
  slideshow: function () {
    var self = this;
    self.imageSlides = new Slicker({
      $slider: $('.h2h-page .carousel-inner'),
      slickOptions: {
        slide: '.single-h2h-page',
        mobileFirst: true,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        paddingBottom: 65,
        paddingLeft: 10,
        responsive: [{
          breakpoint: 1099,
          settings: {
            customPaging: function(slider, i) {
              return '<button class="tab">' + $(slider.$slides[i]).attr('title') + '</button>';
            },
            appendArrows: $('.h2h-page .nav-arrows-holder'),
            prevArrow: '<button tabIndex="0" class="slick-prev-btn datalayer-link" aria-label="Select this arrow to go to previous vehicle comparison slide"><i class="icon icon-arrow-thin-left" data-linktext="compare_selector_previous"></i></button>',
            nextArrow: '<button tabIndex="0" class="slick-next-btn datalayer-link" aria-label="Select this arrow to go to next vehicle comparison slide"><i class="icon icon-arrow-thin-right" data-linktext="compare_selector_next"></i></button>',
          }
        }],
      }
    });
  }
};

export default h2hPage;
